<template>
  <v-form>
    <v-container>
      <v-col>
        <v-text-field
          name="firstName"
          label="First Name"
          id="firstName"
          dense
          outlined
          v-model="value.first_name"
          hide-details="auto"
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          name="lastName"
          label="Last Name"
          id="lastName"
          v-model="value.last_name"
          dense
          outlined
          hide-details="auto"
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          name="email"
          label="Email"
          id="email"
          v-model="value.email"
          dense
          outlined
          hide-details="auto"
          autocomplete="off"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-btn
          color="success"
          block
          dark
          @click.native="formSubmitHandler"
          >Create New User</v-btn
        >
      </v-col>
    </v-container>
  </v-form>
</template>

<script>
  import ActionButton from '@/components/common/actionButton'
  import PermissionAPI from '@/api/PermissionsAPI'
  import { SET_USERS } from '@/appLogic/permissions/store/constants'
  import Toast from '@/components/common/toasts'

  export default {
    components: {
      ActionButton,
    },
    props: {
      value: {
        type: Object,
        default: () => {
          return {
            id: undefined,
            first_name: null,
            last_name: null,
            email: null,
          }
        },
      },
    },
    methods: {
      formSubmitHandler() {
        if (!this.value || !this.value.first_name || !this.value.last_name || !this.value.email) {
          Toast.error({
            title: `Missing User Information`,
            message: `Please make sure you have entered a first name, last name and email address before submitting`,
          })
          return
        }
        this.createUser()
      },
      createUser() {
        this.value.email = this.value.email.toLowerCase()
        PermissionAPI.upsertUser(this.value)
          .then(resp => {
            if (resp) {
              this.resetUserForm()
              Toast.success({
                title: `Create User Succeeded`,
                message: `User ${resp.first_name} ${resp.last_name} has been created`,
              })
              PermissionAPI.getUsers().then(res => {
                this.$store.dispatch(SET_USERS, res)
              })
            }
          })
          .catch(err => {
            console.log('Save User has failed', err)
            Toast.error({
              title: 'Create User Error',
              message: 'Create User has failed, please refresh and try again',
              timeout: 15000,
            })
          })
      },
      resetUserForm() {
        this.value.id = null
        this.value.first_name = ''
        this.value.last_name = ''
        this.value.email = ''
      },
    },
  }
</script>

<style lang="scss">
  .user-form {
    div {
      margin: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// UserForm.vue?50fbb21c